import { useQuery } from '@tanstack/react-query';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from 'recharts';
import { api } from '../../lib/api.js';
import { ErrorBoundary } from '../ErrorBoundary.js';

function Chart() {
  const { data, isLoading } = useQuery({
    queryKey: ['stats'],
    queryFn: () => api.getDashboardStats(),
    refetchInterval: 60_000,
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-48 text-sm text-text-dimmed">
        Loading…
      </div>
    );
  }

  const rows = data?.conflictsByKindAndSeverity ?? [];

  if (rows.length === 0) {
    return (
      <div className="flex items-center justify-center h-48 text-sm" style={{ color: 'var(--accent-green)' }}>
        ✓ No open conflicts
      </div>
    );
  }

  return (
    <div>
      <div className="text-xs font-semibold uppercase tracking-widest text-text-secondary mb-4">
        Open conflicts · by kind
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={rows} barCategoryGap="25%">
          <XAxis
            dataKey="kind"
            tick={{ fill: 'var(--text-dimmed)', fontSize: 10 }}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            tick={{ fill: 'var(--text-dimmed)', fontSize: 10 }}
            tickLine={false}
            axisLine={false}
            allowDecimals={false}
          />
          <Tooltip
            contentStyle={{
              background: 'rgba(14,58,68,0.95)',
              border: '1px solid rgba(13,207,184,0.25)',
              borderRadius: 8,
              fontSize: 12,
              color: '#f0fafa',
            }}
          />
          <Legend wrapperStyle={{ fontSize: 11, color: 'var(--text-secondary)' }} />
          <Bar dataKey="critical" name="Critical" fill="#ee5d50" radius={[2, 2, 0, 0]} />
          <Bar dataKey="high" name="High" fill="#ff8c00" radius={[2, 2, 0, 0]} />
          <Bar dataKey="medium" name="Medium" fill="#ffd166" radius={[2, 2, 0, 0]} />
          <Bar dataKey="low" name="Low" fill="#7bbab8" radius={[2, 2, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function ConflictsChart() {
  return (
    <div
      className="glass rounded-2xl p-5"
      style={{ boxShadow: '0 3px 20px rgba(0,0,0,0.3)' }}
    >
      <ErrorBoundary>
        <Chart />
      </ErrorBoundary>
    </div>
  );
}
